import { toCanvas } from 'qrcode';

function drawQRinHTMLCanvas(text, canvas, opts) {
  toCanvas(canvas, text, opts);
}

export { drawQRinHTMLCanvas };
